import React from 'react'
import './LibaryTab.css'

function LibraryTab() {
    return (
        <div className="library">
            <h1>Library</h1>
        </div>
    )
}

export default LibraryTab
